import { AppInputSwitcher } from "../../components/Layouts/AppInputSwitcher/AppInputSwitcher";
import React, { useEffect, useState } from "react";
import { createFilterOptions } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BOOKING_ACTIONS } from "../../store/onlineBooking";
import { useDispatch } from "react-redux";
import BookingGetters from "../../store/onlineBooking/getters";
import { useWebCheckInForm } from "../../hooks/WebCheckInForm_2";
import { PrivateCustomerDetailFormField } from "./UserDetailsForm";
import {
  DefaultValuesDetailsForm,
  DetailsFormValues,
} from "../../components/Layouts/WebCheckInForms/WebCheckInForms.props";
import { useSearchParams } from "react-router-dom";
import AppCountrySelect from "../../components/Layouts/AppCountrySelect";

function PrivatePersonalDetails({
  userDetails,
  setUserDetails,
  dateError,
  isAirport,
  hideNumberOfFieldsAtPayAtDesk,
  hideNumberOfFieldsAtPayNow,
  paymentType,
}) {
  const [searchParams] = useSearchParams();
  const isResSoucePayNow =
    searchParams.get("reservationSourcePayNow") === "true";
  const isScriptChannel =
    searchParams.get("isInvalidScriptChannelResSource") === "true";
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();
  const appSettings = BookingGetters.getAppSettings();

  const [formStates, formFields] = useWebCheckInForm(
    { ...PrivateCustomerDetailFormField },
    userDetails,
    (e) => {
      setUserDetails((prevDetails) => {
        return {
          ...prevDetails,
          customerType: "Private",
          ...e,
        };
      });
    }
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(BOOKING_ACTIONS.setUserDetails(userDetails));
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [userDetails, dispatch]);

  const isSmallScreen = window.innerWidth <= 768;
  const istabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;

  useEffect(() => {
    if (!userDetails?.sex) return;

    let normalized = userDetails.sex;

    if (["MASCULINO", "HOMME"].includes(userDetails.sex)) {
      normalized = "MASCHIO";
    }

    if (["FEMININA", "FEMME"].includes(userDetails.sex)) {
      normalized = "FEMMINA";
    }

    setUserDetails((prev: any) => ({ ...prev, sex: normalized }));
  }, [userDetails?.sex]);

  const cityFilterOptions = createFilterOptions({
    limit: 50,
    matchFrom: "start",
  });

  const mapSexForUI = (sex: string): string => {
    if (sex === "MASCHIO") return translate("MALE");
    if (sex === "FEMMINA") return translate("FEMALE");
    return sex;
  };

  return (
    <>
      <div
        className="bg-white box-border justify-center"
        style={{
          padding: isSmallScreen ? "0px" : "2rem",
        }}
      >
        <div
          className={`grid sm:grid-cols-2 w-full ${
            istabletScreen ? "md:grid-cols-2" : "md:grid-cols-3"
          } gap-4`}
        >
          {Object.values(formFields).map((el) => {
            if (el.key === "flightNumber" && !appSettings?.flightNumber) {
              return null;
            }
            let isRequired;
            if (el.key === "flightNumber") {
              if (appSettings?.flightNumberRequired) {
                isRequired = true;
              } else if (
                appSettings?.flightNumberRequiredForAirport &&
                isAirport === "true"
              ) {
                isRequired = true;
              } else {
                isRequired = false;
              }
            } else {
              isRequired = true;
            }
            if (
              el.key === "country" ||
              el.key === "state" ||
              el.key === "zip" ||
              el.key === "streetName" ||
              el.key === "birthNation" ||
              el.key === "dateOfBirth" ||
              el.key === "birthPlace" ||
              el.key === "birthProvince" ||
              el.key === "ssnNumber" ||
              el.key === "sex" ||
              el.key === "city" ||
              el.key === "streetNumber"
            ) {
              if (appSettings?.showOnePayMethodTwoPrice) {
                isRequired = true;
              } else {
                isRequired = !(
                  (paymentType === "payNow" && hideNumberOfFieldsAtPayNow) ||
                  (paymentType === "payLater" && hideNumberOfFieldsAtPayAtDesk)
                );
              }
            }

            if (el.key === "country" || el.key === "birthNation") {
              return (
                <div key={el.key} className="country-section">
                  <AppCountrySelect
                    label={el.label}
                    fieldKey={el.key}
                    value={userDetails[el.key]}
                    options={el.options || []}
                    required={isRequired}
                    translate={translate}
                    formStates={formStates}
                    setUserDetails={setUserDetails}
                    onChange={(val: string) => formStates.setValue(el.key, val)}
                    cityFieldName={el.key === "country" ? "city" : "birthPlace"}
                    stateFieldName={
                      el.key === "country" ? "state" : "birthProvince"
                    }
                  />
                </div>
              );
            }
            return (
              <AppInputSwitcher
                {...el}
                key={el.key}
                required={isRequired}
                placeholder={translate(el.placeholder || "")}
                label={translate(el.label || "")}
                className="h-20 sm:w-full box-border sm:px-0 md:px-8"
                value={
                  el.key === "sex"
                    ? mapSexForUI(userDetails.sex)
                    : userDetails[el.key] || formStates.getValues(el.key)
                }
                options={
                  el.key === "sex"
                    ? [translate("MALE"), translate("FEMALE")]
                    : el.options
                }
                {...((el.key === "city" || el.key === "birthPlace") && {
                  filterOptions: cityFilterOptions,
                })}
                dateError={dateError}
                onchange={(e) => {
                  formStates.setValue(el.key, e.toString(), {});
                }}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}

export default PrivatePersonalDetails;
